const getEstimatedArrivalDate = (currentDate, numDays, bufferDays = 0) => {
  let totalDeliveryDays = numDays;
  // convert the date obj to EST date/time zone since the cutoff is based on EST
  const userCurrentDate = new Date(
    currentDate,
  );
  if (userCurrentDate.getDay() === 0 || userCurrentDate.getDay() === 6) {
    totalDeliveryDays += bufferDays;
  }
  userCurrentDate.setDate(userCurrentDate.getDate() - 1);
  while (totalDeliveryDays > 0) {
    // Check if the current day is not a weekend (Saturday or Sunday)
    userCurrentDate.setDate(userCurrentDate.getDate() + 1);
    if (userCurrentDate.getDay() !== 0 && userCurrentDate.getDay() !== 6) {
      totalDeliveryDays--;
    }
  }
  return userCurrentDate;
};

const eligibilityCheckForSTHBadging = (eventData, deliveryDays, categoryID, userDate = new Date()) => {
  const campaignStartDate = new Date(eventData.startTime);
  const campaignCutoffDate = new Date(eventData.endTime);

  if (eventData.eventAttributes.length) {
    if (eventData.categoryIds && eventData.categoryIds.length) {
      if (!eventData.categoryIds.includes(categoryID)) return false;
    }

    const standardCutOffDate = new Date(eventData.eventAttributes[0].cutOffTime);
    const expressCutOffDate = eventData.eventAttributes[0].expressCutOffTime ? new Date(eventData.eventAttributes[0].expressCutOffTime) : false;

    if (userDate >= campaignStartDate && userDate <= campaignCutoffDate) {
      const bufferDays = eventData.eventAttributes[0].bufferDays || 0;
      const standardArrivalDate = getEstimatedArrivalDate(userDate, deliveryDays.standardDeliveryDays,
        Number(bufferDays));
      const expressArrivalDate = deliveryDays.expressDeliveryDays && getEstimatedArrivalDate(userDate, deliveryDays.expressDeliveryDays,
        Number(bufferDays));

      const isVirtualGiftCard = eventData.eventAttributes[0].orderType === 'EMAIL';

      const showStandardMessage = isVirtualGiftCard ? userDate <= campaignCutoffDate && userDate <= standardCutOffDate
        : standardArrivalDate <= campaignCutoffDate && userDate <= standardCutOffDate;
      const showExpressMessage = expressArrivalDate && expressCutOffDate ? expressArrivalDate <= campaignCutoffDate
      && userDate <= expressCutOffDate : false;

      if (showStandardMessage) return { message: eventData.eventAttributes[0].message, color: eventData.badgingColor };

      if (showExpressMessage) return { message: eventData.eventAttributes[0].expressMessage, color: eventData.badgingColor };
    }
  }

  return false;
};

export default eligibilityCheckForSTHBadging;
